/* src/components/quickscan-create-update-question-modal/quickscan-create-update-question-modal.component.scss */
:host {
  display: block;
}
.answer__fields {
  display: table;
  table-layout: fixed;
  width: 100%;
}
.answer__field {
  display: table-cell;
  vertical-align: middle;
  padding: 0 var(--vwui-size-spacing-xs) 0 0;
}
.answer__field--score {
  width: 5rem;
}
.answer__field--red-flag {
  width: 7rem;
  padding-left: var(--vwui-size-spacing-xs);
}
.answer__field--remove {
  width: 35px;
  text-align: right;
  padding: 0;
}
/*# sourceMappingURL=quickscan-create-update-question-modal.component-YJONW5P5.css.map */
